module.exports = {
	"@extends": "../config.json5",
	"auth": {
		"auth0": {
			"clientId": "tqTF5y9cmuzSFHVeWOACeP74d7VpjaLq",
			"url": "https://gw-test.eu.auth0.com",
			"redirectPath": "/dist/html/common/login-redirect.html"
		}
	}
}